module.exports = __webpack_public_path__ + "img/7.2b9fa3d3.png";